import { createFileRoute } from '@tanstack/react-router'
import { UserDeletePage } from '@/features/users/delete'

export const Route = createFileRoute('/users_/$userId/delete')({
  component: RouteComponent,
})

function RouteComponent() {
  const { userId } = Route.useParams()
  return <UserDeletePage userId={userId} />
}
